import { axiosBase } from 'utils';

const axios = axiosBase.create();

export function rackRegistryListService() {
  return axios.get('/rackregistry');
}

export function rackRegistryCreateService(data) {
  return axios.post('/rackregistry', data);
}

export function rackRegistryDeleteService(id) {
  return axios.delete(`/rackregistry/${id}`);
}

export function rackRegistryUpdateService(id, data) {
  return axios.patch(`/rackregistry/${id}`, data);
}

export function rackRegistryGetByIdService(id) {
  return axios.get(`/rackregistry/${id}`);
}

export function rackRegistryDiagramDataService(id) {
  return axios.get(`/rackregistry/${id}/diagram-data`);
}
